import { scroller } from 'react-scroll';

export class UtilityManager {

    public static scrollToEl(element: string) {

        scroller.scrollTo(element, {
            duration: 800,
            delay: 0,
            smooth: 'easeInOutQuart'
        });

    }

}


// WEBPACK FOOTER //
// ./src/core/utility/UtilityManager.tsx